import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { CLOSE_NOTIFICATION } from '../../redux/slices/showNotificationSlice'

const Toast = () => {
    const selector = useAppSelector((state) => state.showNotification)
    const [isHovered, setIsHovered] = useState(false)
    const dispatch = useAppDispatch()
    const handleCloseToast = () => {
        dispatch(CLOSE_NOTIFICATION())
    }
    useEffect(() => {
        let timeoutId: NodeJS.Timeout

        if (selector.show && !isHovered) {
            timeoutId = setTimeout(() => {
                dispatch(CLOSE_NOTIFICATION())
            }, 3000)
        }

        return () => {
            clearTimeout(timeoutId)
        }
    }, [selector.show, isHovered, dispatch])
    return (
        <>
            <div
                className="position-fixed top-0 end-0 p-3"
                style={{ zIndex: 11 }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div
                    className="toast show"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                >
                    <div
                        className="toast-header"
                        style={{
                            backgroundColor: `${selector.type == 'error' ? '#eb4c59' : '#03f39e'}`,
                        }}
                    >
                        <strong className="me-auto">{selector.type}</strong>
                        <button
                            onClick={handleCloseToast}
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="toast"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="toast-body">{selector.message}</div>
                </div>
            </div>
        </>
    )
}
export default Toast
